<div class="content" [class.desktop]="desktop">
  <div class="block advantage">
    <div class="subtitle">
      <span class="icon-up"></span>
      <span class="label">Vorteil</span>
    </div>
    <p class="description">{{ advantage }}</p>
  </div>
  @if (desktop) {
    <div class="divider"></div>
  }
  <div class="block risk">
    <div class="subtitle">
      <span class="icon-down"></span>
      <span class="label">Risiko</span>
    </div>
    <p class="description">{{ risk }}</p>
  </div>
</div>
